// reducers.js

import { combineReducers } from "redux";
import auth from "./auth";
import { getAllCustomersReducer } from "./customer";
import { getAllFinancesReducer } from "./finance";
import { getAllEmployeesReducer } from "./employee";
import { getAllRolesReducer } from "./roles"; 
import { getAllInquiryReducer } from "./inquiry";
import { getAllInquiryTypeReducer } from "./inquiry";
import fileReducer from "./fileReducers";
import filterReducer from "../apps/hunting/reducers";
import leadReducer from "../apps/leads/reducers";
import cvReducer from "../apps/cv/reducers";
import jobOrderReducer from "../apps/jobOrders/reducers";

export default combineReducers({
  auth,
  customerList: getAllCustomersReducer,
  financeList: getAllFinancesReducer,
  employeeList: getAllEmployeesReducer,
  roleList: getAllRolesReducer,
  inquiryList: getAllInquiryReducer,
  inquiryTypeList: getAllInquiryTypeReducer,
  file: fileReducer,
  filtered: filterReducer,
  lead: leadReducer,
  cv: cvReducer,
  jobOrder: jobOrderReducer,
});